import CopyToClipboard from '../../../common/copyToClipboard';

const PaymentLink = ({ paymentLink }) => {

    return (
        <div className="w-100 text-center">
                <h3>Payment Link</h3>
            <div className='d-flex'>
                <div style={{"whiteSpace": "nowrap", "overflow": "hidden", "textOverflow": "ellipsis"}}>
                <a style={{ textDecoration: "none", fontSize: "18px" }} href={paymentLink}>{paymentLink}</a>
            </div>

            <div>
                <CopyToClipboard textToCopy={paymentLink} />
            </div>
            </div>
        </div>
    )
}

export default PaymentLink